export enum CustomizeLabelAndMarkerTab {
  Label = 'CustomizeLabelAndMarker-Label',
  Marker = 'CustomizeLabelAndMarker-Marker',
}
